import React, { Component } from "react";
import classes from "./RefundForm.css";
import global from "../../../global.css";
import ValidationCenter from "../../../ValidationCenter/ValidationCenter";
import { connect } from "react-redux";
import {
  RequestForBankName,
  RequestForAddRefund,
  RequestForEditRefund,
  ItemSelectedForEditRefund,
  alertMessenger,
  RefundSuccessAdd,
  RefundSuccessEdit,
  modalStatusToggle
} from "../../../store/action/index";
import RefundLaw from "./RefundLaw/RefundLaw";

class RefundFrom extends Component {
  state = {
    ShowRefunbBox: false,
    AgreeBTN: false,
    BankList: null,
    Spiner: false,
    RequestedNumber: null,
    nameLeader: {
      value: "",
      validation: false,
      touch: false,
      message: null
    },
    PNR: {
      value: "",
      validation: false,
      touch: false,
      message: null
    },
    TicketNum: {
      value: "",
      validation: false,
      touch: false,
      message: null
    },
    refund: {
      value: "",
      validation: false,
      touch: false,
      message: null
    },
    personNameAcount: {
      value: "",
      validation: false,
      touch: false,
      message: null
    },
    // email: {
    //     value: "",
    //     validation: false,
    //     touch: false,
    // },
    // mobile: {
    //     value: "",
    //     validation: false,
    //     touch: false,
    // },
    // phone: {
    //     value: "",
    //     validation: false,
    //     touch: false,
    // },
    Shaba: {
      value: "",
      validation: false,
      touch: false,
      message: null
    },
    AccountNumber: {
      value: "",
      validation: false,
      touch: false,
      message: null
    },
    CardNumber: {
      value: "",
      validation: false,
      touch: false,
      message: null
    },
    BankId: {
      value: "",
      validation: false,
      touch: false,
      message: null
    },
    exterainfo: {
      value: "",
      validation: true,
      touch: false
    },
    Id: {
      value: "0",
      validation: false,
      touch: false
    }
  };

  InputHandler = (event, key) => {
    event.persist();
    this.setState(prevState => {
      return {
        [key]: {
          ...prevState[key],
          value: event.target.value,
          touch: true,
          message: null
        }
      };
    });
  };

  Validation = props => {
    let PayBackValid = ValidationCenter(props);
    if (!PayBackValid.valid) {
      if (PayBackValid.Message) {
        this.setState(prevState => {
          return {
            [props.FieldName]: {
              ...prevState[props.FieldName],
              validation: false,
              message: PayBackValid.Message
            }
          };
        });
      }
    } else {
      this.setState(prevState => {
        return {
          [props.FieldName]: {
            ...prevState[props.FieldName],
            validation: true
          }
        };
      });
    }
  };

  SelectValidation = FieldName => {
    if (
      this.state[FieldName].value === "" ||
      this.state[FieldName].value === "0"
    ) {
      this.setState(prevState => {
        return {
          [FieldName]: {
            ...prevState[FieldName],
            validation: false,
            message: "مقدار انتخابی اشتباه است"
          }
        };
      });
    } else {
      this.setState(prevState => {
        return {
          [FieldName]: {
            ...prevState[FieldName],
            validation: true
          }
        };
      });
    }
  };

  componentDidMount = () => {
    this.props.RequestForBankName();
  };

  EraseFrom = () => {
    this.setState({
      Spiner: false,
      RequestedNumber: null,
      nameLeader: {
        value: "",
        validation: false,
        touch: false,
        message: null
      },
      PNR: {
        value: "",
        validation: false,
        touch: false,
        message: null
      },
      TicketNum: {
        value: "",
        validation: false,
        touch: false,
        message: null
      },
      refund: {
        value: "",
        validation: false,
        touch: false,
        message: null
      },
      personNameAcount: {
        value: "",
        validation: false,
        touch: false,
        message: null
      },
      // email: {
      //     value: "",
      //     validation: false,
      //     touch: false,
      // },
      // mobile: {
      //     value: "",
      //     validation: false,
      //     touch: false,
      // },
      // phone: {
      //     value: "",
      //     validation: false,
      //     touch: false,
      // },
      Shaba: {
        value: "",
        validation: false,
        touch: false,
        message: null
      },
      AccountNumber: {
        value: "",
        validation: false,
        touch: false,
        message: null
      },
      CardNumber: {
        value: "",
        validation: false,
        touch: false,
        message: null
      },
      BankId: {
        value: "",
        validation: false,
        touch: false,
        message: null
      },
      exterainfo: {
        value: "",
        validation: true,
        touch: false
      },
      Id: {
        value: "0",
        validation: false,
        touch: false
      }
    });
  };

  componentWillReceiveProps = props => {
    if (props.selecteValue) {
      this.autoFill(props.selecteValue);
    }
    if (props.ResultOfEditRefund || props.ResultOfAddRefund) {
      this.setState({
        Spiner: false
      });
      this.EraseFrom();
      this.props.RefundSuccessAdd();
      this.props.RefundSuccessEdit();
    } else {
      this.setState({
        Spiner: false
      });
    }
  };

  autoFill = item => {
    this.setState(
      prevState => {
        return {
          nameLeader: {
            value: item.PassengersHeaderFullName,
            validation: false,
            touch: true,
            message: null
          },
          PNR: {
            value: item.PNR,
            validation: false,
            touch: true,
            message: null
          },
          TicketNum: {
            value: item.Watcher,
            validation: false,
            touch: true,
            message: null
          },
          refund: {
            value: item.RefundReasonId,
            validation: false,
            touch: true,
            message: null
          },
          personNameAcount: {
            value: item.FullName,
            validation: false,
            touch: true,
            message: null
          },
          // email: {
          //     value: "",
          //     validation: false,
          //     touch: false,
          // },
          // mobile: {
          //     value: "",
          //     validation: false,
          //     touch: false,
          // },
          // phone: {
          //     value: "",
          //     validation: false,
          //     touch: false,
          // },
          Shaba: {
            value: item.IBAN.slice(2),
            validation: false,
            touch: true,
            message: null
          },
          AccountNumber: {
            value: item.AccountNumber,
            validation: false,
            touch: true,
            message: null
          },
          CardNumber: {
            value: item.CardNumber,
            validation: false,
            touch: true,
            message: null
          },
          BankId: {
            value: item.BankId,
            validation: false,
            touch: true,
            message: null
          },
          exterainfo: {
            value: item.Description ? item.Description : "",
            validation: true,
            touch: true
          },
          Id: {
            value: item.Id,
            validation: false,
            touch: true
          }
        };
      },
      () => {
        this.SelectValidation("BankId");
        this.SelectValidation("refund");
        this.Validation({
          string: {
            type: "FE",
            minlength: 3,
            maxLength: 50,
            value: this.state.nameLeader.value
          },
          FieldName: "nameLeader"
        });
        this.Validation({
          string: {
            type: "NE",
            minlength: 3,
            maxLength: 20,
            value: this.state.PNR.value
          },
          FieldName: "PNR"
        });
        this.Validation({
          string: {
            type: "NE",
            minlength: 7,
            maxLength: 20,
            value: this.state.TicketNum.value
          },
          FieldName: "TicketNum"
        });
        this.Validation({
          number: {
            type: "NUM",
            minlength: 16,
            maxLength: 16,
            value: this.state.CardNumber.value
          },
          FieldName: "CardNumber"
        });
        this.Validation({
          string: {
            type: "FE",
            minlength: 3,
            maxLength: 50,
            value: this.state.personNameAcount.value
          },
          FieldName: "personNameAcount"
        });
        this.Validation({
          number: {
            type: "NUM",
            minlength: 24,
            maxLength: 24,
            value: this.state.Shaba.value
          },
          FieldName: "Shaba"
        });
        this.Validation({
          number: {
            type: "NUM",
            minlength: 5,
            maxLength: 20,
            value: this.state.AccountNumber.value
          },
          FieldName: "AccountNumber"
        });
      }
    );
    this.props.ItemSelectedForEditRefund();
  };

  CheckRefundLaw = () => {
    if (
      this.state.nameLeader.validation &&
      (this.state.PNR.validation || this.state.TicketNum.validation) &&
      this.state.refund.validation &&
      this.state.personNameAcount.validation &&
      this.state.Shaba.validation &&
      this.state.AccountNumber.validation &&
      this.state.CardNumber.validation &&
      this.state.BankId.validation &&
      this.state.exterainfo.validation
    ) {
      if (localStorage["LOG_IN_WITH_PHONE"]) {
        if (sessionStorage["NO_SHOW_REFUND_LAW"]) {
          this.SendRequest();
        } else if (localStorage["AGREE_REFUND_LAW"]) {
          this.SendRequest();
        } else {
          this.setState({
            ShowRefunbBox: true
          });
        }
      } else {
        this.props.modalStatusToggle("MOBILE");
      }
    } else {
      this.props.alertMessenger("لطفا ورودی های خود را مجددا بررسی نمایید...");
    }
  };

  SendRequest = () => {
    if (
      this.state.nameLeader.validation &&
      (this.state.PNR.validation || this.state.TicketNum.validation) &&
      this.state.refund.validation &&
      this.state.personNameAcount.validation &&
      this.state.Shaba.validation &&
      this.state.AccountNumber.validation &&
      this.state.CardNumber.validation &&
      this.state.BankId.validation &&
      this.state.exterainfo.validation
    ) {
      this.setState({
        Spiner: true
      });
      let Value = {
        PassengersHeaderFullName: this.state.nameLeader.value.trim(),
        PNR: this.state.PNR.value.trim(),
        Watcher: this.state.TicketNum.value.trim(),
        RefundReasonId: this.state.refund.value,
        FullName: this.state.personNameAcount.value.trim(),
        IBAN: "IR" + this.state.Shaba.value.trim(),
        AccountNumber: this.state.AccountNumber.value.trim(),
        CardNumber: this.state.CardNumber.value.trim(),
        BankId: this.state.BankId.value,
        Description: this.state.exterainfo.value.trim(),
        Id: this.state.Id.value,
        RequestedNumber: this.state.RequestedNumber
      };
      if (this.state.Id.value === "0") {
        this.props.RequestForAddRefund(Value);
      } else if (this.props.selecteValue) {
        this.props.ItemSelectedForEditRefund();
        this.props.RequestForEditRefund(Value);
      } else {
        this.props.RequestForEditRefund(Value);
      }
    } else {
      this.props.alertMessenger("لطفا ورودی های خود را مجددا بررسی نمایید...");
    }
  };

  AgreeLaw = () => {
    this.SendRequest();
    this.setState({
      ShowRefunbBox: false
    });
  };

  onDontShow = (event, value) => {
    event.persist();
    switch (value) {
      case "NoShow":
        if (event.target.checked) {
          localStorage.setItem("NO_SHOW_REFUND_LAW", true);
          if (sessionStorage["AGREE_REFUND_LAW"] && this.state.AgreeBTN) {
            localStorage.setItem("AGREE_REFUND_LAW", true);
          }
        } else {
          localStorage.removeItem("NO_SHOW_REFUND_LAW");
          if (localStorage["AGREE_REFUND_LAW"]) {
            localStorage.removeItem("AGREE_REFUND_LAW");
          }
        }
        break;
      case "Agree":
        if (event.target.checked) {
          this.setState({
            AgreeBTN: true
          });
          sessionStorage.setItem("AGREE_REFUND_LAW", true);
        } else {
          this.setState({
            AgreeBTN: false
          });
          if (localStorage["AGREE_REFUND_LAW"]) {
            localStorage.removeItem("AGREE_REFUND_LAW");
          }
          sessionStorage.removeItem("AGREE_REFUND_LAW");
        }
        break;
      default:
        break;
    }
  };

  CloseRefund = () => {
    this.setState({
      ShowRefunbBox: false
    });
  };

  render() {
    return (
      <div id="FormPart">
        {this.state.ShowRefunbBox ? (
          <RefundLaw
            ShowAnimation={this.state.ShowRefunbBox}
            Agree={this.AgreeLaw}
            CloseRefund={this.CloseRefund}
            checkBox={this.onDontShow}
            AgreeBTN={this.state.AgreeBTN}
          />
        ) : null}
        <h2 className={classes.h2}>فرم استرداد آنلاین</h2>
        <div className={classes.FormFather}>
          <div
            className={[global.inputFather, classes.DifrentFather].join(" ")}
          >
            <input
              type="text"
              onChange={e => this.InputHandler(e, "nameLeader")}
              maxLength={50}
              className={
                this.state.nameLeader.message ? global.ErrorField : null
              }
              value={this.state.nameLeader.value}
              onBlur={() =>
                this.Validation({
                  string: {
                    type: "FE",
                    minlength: 3,
                    maxLength: 50,
                    value: this.state.nameLeader.value.trim()
                  },
                  FieldName: "nameLeader"
                })
              }
            />
            {this.state.nameLeader.message ? (
              <span className={global.Error}>
                {this.state.nameLeader.message}
              </span>
            ) : null}
            <label
              className={[
                this.state.nameLeader.touch ? global.LabelMove : null,
                this.state.nameLeader.message ? global.ErrorLabel : null
              ].join(" ")}
            >
              نام و نام خوانوادگی سرگروه
            </label>
          </div>
          <div
            className={[global.inputFather, classes.DifrentFather].join(" ")}
          >
            <input
              type="text"
              onChange={e => this.InputHandler(e, "PNR")}
              maxLength={20}
              className={this.state.PNR.message ? global.ErrorField : null}
              value={this.state.PNR.value}
              onBlur={() =>
                this.Validation({
                  string: {
                    type: "NE",
                    minlength: 3,
                    maxLength: 20,
                    value: this.state.PNR.value.trim()
                  },
                  FieldName: "PNR"
                })
              }
            />
            {this.state.PNR.message ? (
              <span className={global.Error}>{this.state.PNR.message}</span>
            ) : null}
            <label
              className={[
                this.state.PNR.touch ? global.LabelMove : null,
                this.state.PNR.message ? global.ErrorLabel : null
              ].join(" ")}
            >
              شماره رفرنس
            </label>
          </div>
          <div
            className={[global.inputFather, classes.DifrentFather].join(" ")}
          >
            <input
              type="text"
              onChange={e => this.InputHandler(e, "TicketNum")}
              maxLength={20}
              className={
                this.state.TicketNum.message ? global.ErrorField : null
              }
              value={this.state.TicketNum.value}
              onBlur={() =>
                this.Validation({
                  string: {
                    type: "NE",
                    minlength: 7,
                    maxLength: 20,
                    value: this.state.TicketNum.value.trim()
                  },
                  FieldName: "TicketNum"
                })
              }
            />
            {this.state.TicketNum.message ? (
              <span className={global.Error}>
                {this.state.TicketNum.message}
              </span>
            ) : null}
            <label
              className={[
                this.state.TicketNum.touch ? global.LabelMove : null,
                this.state.TicketNum.message ? global.ErrorLabel : null
              ].join(" ")}
            >
              شماره بلیط
            </label>
          </div>
          <div
            className={[global.inputFather, classes.DifrentFather].join(" ")}
          >
            <select
              value={this.state.refund.value}
              onBlur={() => this.SelectValidation("refund")}
              className={this.state.refund.message ? global.ErrorField : null}
              onChange={e => this.InputHandler(e, "refund")}
            >
              <option value={"0"} />
              <option value={"2"}>کنسلی پرواز توسط کاربر(خریدار)</option>
              <option value={"6"}> تغییر ساعت پرواز توسط ایرلاین</option>
              <option value={"1"}>کنسلی پرواز توسط ایرلاین</option>
              <option value={"4"}> تاخیر بیش از دو ساعت</option>
              <option value={"3"}>کنسلی توسط کانتر</option>
              <option value={"5"}>بدی آب و هوا</option>
              <option value={"8"}>خارج از لیست</option>
              <option value={"9"}>متفرقه</option>
              <option value={"7"}>نوشو (No Show)</option>
            </select>
            {this.state.refund.message ? (
              <span className={global.Error}>{this.state.refund.message}</span>
            ) : null}
            <label
              className={[
                this.state.refund.touch ? global.LabelMove : null,
                this.state.refund.message ? global.ErrorLabel : null
              ].join(" ")}
            >
              نوع استرداد
            </label>
          </div>
          <div
            className={[global.inputFather, classes.DifrentFather].join(" ")}
          >
            <input
              type="text"
              onChange={e => this.InputHandler(e, "personNameAcount")}
              maxLength={50}
              className={
                this.state.personNameAcount.message ? global.ErrorField : null
              }
              value={this.state.personNameAcount.value}
              onBlur={() =>
                this.Validation({
                  string: {
                    type: "FE",
                    minlength: 3,
                    maxLength: 50,
                    value: this.state.personNameAcount.value.trim()
                  },
                  FieldName: "personNameAcount"
                })
              }
            />
            {this.state.personNameAcount.message ? (
              <span className={global.Error}>
                {this.state.personNameAcount.message}
              </span>
            ) : null}
            <label
              className={[
                this.state.personNameAcount.touch ? global.LabelMove : null,
                this.state.personNameAcount.message ? global.ErrorLabel : null
              ].join(" ")}
            >
              نام و نام خانوادگی صاحب حساب
            </label>
          </div>
          <div
            className={[global.inputFather, classes.DifrentFather].join(" ")}
          >
            <span className={classes.IRDefult}> - IR</span>
            <input
              type="text"
              onChange={e => this.InputHandler(e, "Shaba")}
              className={this.state.Shaba.message ? global.ErrorField : null}
              maxLength={24}
              dir="ltr"
              style={{ textIndent: "35px" }}
              value={this.state.Shaba.value}
              onBlur={() =>
                this.Validation({
                  number: {
                    type: "NUM",
                    minlength: 24,
                    maxLength: 24,
                    value: this.state.Shaba.value.trim()
                  },
                  FieldName: "Shaba"
                })
              }
            />
            {this.state.Shaba.message ? (
              <span className={global.Error}>{this.state.Shaba.message}</span>
            ) : null}
            <label
              className={[
                this.state.Shaba.touch ? global.LabelMove : null,
                this.state.Shaba.message ? global.ErrorLabel : null
              ].join(" ")}
            >
              شماره شبا
            </label>
            <a
              href="https://idpay.ir/banks"
              rel="noopener noreferrer nofollow"
              target="_blank"
              className={classes.ShabaYab}
            >
              دریافت شبای حساب
            </a>
          </div>
          <div
            className={[global.inputFather, classes.DifrentFather].join(" ")}
          >
            <input
              type="text"
              onChange={e => this.InputHandler(e, "AccountNumber")}
              className={
                this.state.AccountNumber.message ? global.ErrorField : null
              }
              maxLength={22}
              value={this.state.AccountNumber.value}
              onBlur={() =>
                this.Validation({
                  number: {
                    type: "NUM",
                    minlength: 6,
                    maxLength: 22,
                    value: this.state.AccountNumber.value.trim()
                  },
                  FieldName: "AccountNumber"
                })
              }
            />
            {this.state.AccountNumber.message ? (
              <span className={global.Error}>
                {this.state.AccountNumber.message}
              </span>
            ) : null}
            <label
              className={[
                this.state.AccountNumber.touch ? global.LabelMove : null,
                this.state.AccountNumber.message ? global.ErrorLabel : null
              ].join(" ")}
            >
              شماره حساب
            </label>
          </div>
          <div
            className={[global.inputFather, classes.DifrentFather].join(" ")}
          >
            <input
              type="text"
              onChange={e => this.InputHandler(e, "CardNumber")}
              className={
                this.state.CardNumber.message ? global.ErrorField : null
              }
              maxLength={16}
              value={this.state.CardNumber.value}
              onBlur={() =>
                this.Validation({
                  number: {
                    type: "NUM",
                    minlength: 16,
                    maxLength: 16,
                    value: this.state.CardNumber.value.trim()
                  },
                  FieldName: "CardNumber"
                })
              }
            />
            {this.state.CardNumber.message ? (
              <span className={global.Error}>
                {this.state.CardNumber.message}
              </span>
            ) : null}
            <label
              className={[
                this.state.CardNumber.touch ? global.LabelMove : null,
                this.state.CardNumber.message ? global.ErrorLabel : null
              ].join(" ")}
            >
              شماره کارت{" "}
            </label>
          </div>
          <div
            className={[global.inputFather, classes.DifrentFather].join(" ")}
          >
            <select
              value={this.state.BankId.value}
              onBlur={() => this.SelectValidation("BankId")}
              className={this.state.BankId.message ? global.ErrorField : null}
              onChange={e => this.InputHandler(e, "BankId")}
            >
              {this.props.BanklIst ? (
                this.props.BanklIst.map(item => {
                  return (
                    <option key={item.Id} value={item.Id}>
                      {item.BankName}
                    </option>
                  );
                })
              ) : (
                <option value={"0"}>درحال دریافت اطلاعات...</option>
              )}
            </select>
            {this.state.BankId.message ? (
              <span className={global.Error}>{this.state.BankId.message}</span>
            ) : null}
            <label
              className={[
                this.state.BankId.touch ? global.LabelMove : null,
                this.state.BankId.message ? global.ErrorLabel : null
              ].join(" ")}
            >
              نام بانک
            </label>
          </div>
          <div className={[global.inputFather, classes.OddInput].join(" ")}>
            <textarea
              rows="6"
              onChange={e => this.InputHandler(e, "exterainfo")}
              maxLength={1000}
              value={this.state.exterainfo.value}
            />
            <label
              className={this.state.exterainfo.touch ? global.LabelMove : null}
            >
              توضیحات
            </label>
            <input hidden onChange={() => {}} value={this.state.Id.value} />
          </div>
        </div>
        <button
          onClick={this.CheckRefundLaw}
          className={this.state.Spiner ? global.Load : null}
          disabled={this.state.Spiner}
        >
          <span className={this.state.Spiner ? global.Loader : null} />
          ثبت
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    BanklIst: state.REFUND.BanklIst,
    selecteValue: state.REFUND.selecteValue,
    SMS: state.ALERT.SMS,
    ResultOfEditRefund: state.REFUND.ResultOfEditRefund,
    ResultOfAddRefund: state.REFUND.ResultOfAddRefund
  };
};

const mapDispatchToProps = dispatch => {
  return {
    modalStatusToggle: value => dispatch(modalStatusToggle(value)),
    RequestForAddRefund: value => dispatch(RequestForAddRefund(value)),
    RequestForEditRefund: value => dispatch(RequestForEditRefund(value)),
    RefundSuccessAdd: () => dispatch(RefundSuccessAdd()),
    RefundSuccessEdit: () => dispatch(RefundSuccessEdit()),
    RequestForBankName: () => dispatch(RequestForBankName()),
    ItemSelectedForEditRefund: val => dispatch(ItemSelectedForEditRefund(val)),
    alertMessenger: SMS => dispatch(alertMessenger(SMS))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RefundFrom);
